function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { Label } from 'reactstrap';

var LabelCustom = function LabelCustom(props) {
  var className = props.className,
      cssModule = props.cssModule,
      hidden = props.hidden,
      widths = props.widths,
      invalid = props.invalid,
      valid = props.valid,
      Tag = props.tag,
      check = props.check,
      size = props.size,
      htmlFor = props.for,
      attributes = _objectWithoutProperties(props, ['className', 'cssModule', 'hidden', 'widths', 'invalid', 'valid', 'tag', 'check', 'size', 'for']);

  var classes = [invalid ? "is-invalid" : "", valid ? "was-valid" : "", className ? "" + className : ""];

  return React.createElement(Label, Object.assign({}, attributes, { className: classes
  }));
};

export default LabelCustom;